import {
  AssuredWorkload,
  Chat,
  DevicesOther,
  EventAvailable,
  ExpandLess,
  ExpandMore,
  Gavel,
  Group,
  HealthAndSafety,
  LocalGroceryStore,
  LocationCity,
  LocationOn,
  ManageAccounts,
  Public,
  Storage,
  TabletAndroid,
} from '@mui/icons-material';
import {
  Collapse,
  Drawer,
  Grid,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import React from 'react';
import { FSDirectoryOverview } from '../FSDirectory/FSDirectoryOverview';
import { useNavigate, useParams } from 'react-router-dom';
import { LanguageSectionOverview } from '../LanguageSection/LanguageSectionOverview';
import NotReadyYet from '../../generic/NotReadyYet';
import { UserOverview } from '../UserSetting/User/UserOverview';
import { UserGroupOverview } from '../UserSetting/UserGroup/UserGroupOverview';
import { ExtensionsView } from '../../Marketplace/ExtensionsView';
import { LocationOverview } from '../Location/LocationOverview';
import { CourtOverview } from '../Court/CourtOverview';
import { LandregisterSettingOverview } from '../LandregisterSetting/LandregisterSettingOverview';
import { MeetingBookingSettings } from '../../Settings/MeetingBooking/MeetingBookingSettings';
import { OpenFormulareDialogsView } from '../OpenFormulareDialogs/OpenFormulareDialogsView';
import { TabletsView } from '../Devices/TabletsView';
import { HealthCheckView } from '../HealthCheck/HealthCheckView';
import { useGetAppArray } from '../../hooks/reactQuerys/AppQueries';
import { PostcodeAdminOverview } from '../Postcode/PostcodeAdminOverview';

enum SETTING_SITE {
  GLOBAL = 'generic',
  GROUPS = 'groups',
  USER = 'user',
  LOCATIONS = 'locations',
  APPOINTMENTS = 'appointments',
  COURTS = 'courts',
  FS_Directories = 'fsdirectory',
  LANGUAGE = 'language',
  LANDREGISTER = 'landregister',
  POSTCODES = 'postcodes',
  APPS = 'apps',
  OF_DIALOGS = 'ofdialogs',
  DEVICES_TABLETS = 'devices-tablets',
  HEALTH_CHECK = 'healthcheck',
}

const DEVICE_VIEWS = new Set<string>([SETTING_SITE.DEVICES_TABLETS]);

export const SystemSettingsView: React.FC = () => {
  const { currentView } = useParams();
  const navigate = useNavigate();
  const { appArray } = useGetAppArray();
  const ofActive =
    appArray?.find(a => a.system_key === 'open_formulare')?.IsEffective ===
    true;
  const tabletServiceActive =
    appArray?.find(a => a.system_key === 'dino_tablet_service')?.IsEffective ===
    true;
  const anyDeviceExtensionActive = tabletServiceActive;
  const [devicesOpen, setDevicesOpen] = React.useState<boolean>(
    !!currentView && DEVICE_VIEWS.has(currentView)
  );

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={3}>
          <List>
            <ListItemButton
              onClick={() => navigate(`/admin/${SETTING_SITE.GLOBAL}`)}
            >
              <ListItemIcon>
                <Public />
              </ListItemIcon>
              <ListItemText>Grundeinstellungen</ListItemText>
            </ListItemButton>

            <ListItemButton
              onClick={() => navigate(`/admin/${SETTING_SITE.GROUPS}`)}
            >
              <ListItemIcon>
                <Group />
              </ListItemIcon>
              <ListItemText>Gruppen</ListItemText>
            </ListItemButton>

            <ListItemButton
              onClick={() => navigate(`/admin/${SETTING_SITE.USER}`)}
            >
              <ListItemIcon>
                <ManageAccounts />
              </ListItemIcon>
              <ListItemText>Benutzer</ListItemText>
            </ListItemButton>

            {ofActive && (
              <ListItemButton
                onClick={() => navigate(`/admin/${SETTING_SITE.OF_DIALOGS}`)}
              >
                <ListItemIcon>
                  <Chat />
                </ListItemIcon>
                <ListItemText>Dialoge</ListItemText>
              </ListItemButton>
            )}
            <ListItemButton
              onClick={() => navigate(`/admin/${SETTING_SITE.LOCATIONS}`)}
            >
              <ListItemIcon>
                <LocationOn />
              </ListItemIcon>
              <ListItemText>Standorte</ListItemText>
            </ListItemButton>

            <ListItemButton
              onClick={() => navigate(`/admin/${SETTING_SITE.APPOINTMENTS}`)}
            >
              <ListItemIcon>
                <EventAvailable />
              </ListItemIcon>
              <ListItemText>Termine</ListItemText>
            </ListItemButton>

            <ListItemButton
              onClick={() => navigate(`/admin/${SETTING_SITE.FS_Directories}`)}
            >
              <ListItemIcon>
                <Storage />
              </ListItemIcon>
              <ListItemText>Ordnerverwaltung</ListItemText>
            </ListItemButton>

            <ListItemButton
              onClick={() => navigate(`/admin/${SETTING_SITE.COURTS}`)}
            >
              <ListItemIcon>
                <Gavel />
              </ListItemIcon>
              <ListItemText>Ämterverwaltung</ListItemText>
            </ListItemButton>

            <ListItemButton
              onClick={() => navigate(`/admin/${SETTING_SITE.LANDREGISTER}`)}
            >
              <ListItemIcon>
                <AssuredWorkload />
              </ListItemIcon>
              <ListItemText>Grundbuchanbindung</ListItemText>
            </ListItemButton>

            <ListItemButton
              selected={currentView === SETTING_SITE.POSTCODES}
              onClick={() => navigate(`/admin/${SETTING_SITE.POSTCODES}`)}
            >
              <ListItemIcon>
                <LocationCity />
              </ListItemIcon>
              <ListItemText>Postleitzahlen</ListItemText>
            </ListItemButton>

            {/*
            <ListItemButton
              onClick={() => navigate(`/admin/${SETTING_SITE.LANGUAGE}`)}
            >
              <ListItemIcon>
                <Translate />
              </ListItemIcon>
              <ListItemText>Sprachpakete (BETA)</ListItemText>
            </ListItemButton>
             */}

            {anyDeviceExtensionActive && (
              <>
                <ListItemButton onClick={() => setDevicesOpen(o => !o)}>
                  <ListItemIcon>
                    <DevicesOther />
                  </ListItemIcon>
                  <ListItemText>Geräte</ListItemText>
                  {devicesOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
                <Collapse in={devicesOpen} timeout='auto' unmountOnExit>
                  <List component='div' disablePadding>
                    {tabletServiceActive && (
                      <ListItemButton
                        sx={{ pl: 4 }}
                        selected={currentView === SETTING_SITE.DEVICES_TABLETS}
                        onClick={() =>
                          navigate(`/admin/${SETTING_SITE.DEVICES_TABLETS}`)
                        }
                      >
                        <ListItemIcon>
                          <TabletAndroid />
                        </ListItemIcon>
                        <ListItemText>Tablets</ListItemText>
                      </ListItemButton>
                    )}
                  </List>
                </Collapse>
              </>
            )}

            <ListItemButton
              onClick={() => navigate(`/admin/${SETTING_SITE.APPS}`)}
            >
              <ListItemIcon>
                <LocalGroceryStore />
              </ListItemIcon>
              <ListItemText>Erweiterungen</ListItemText>
            </ListItemButton>

            <ListItemButton
              selected={currentView === SETTING_SITE.HEALTH_CHECK}
              onClick={() => navigate(`/admin/${SETTING_SITE.HEALTH_CHECK}`)}
            >
              <ListItemIcon>
                <HealthAndSafety />
              </ListItemIcon>
              <ListItemText>Health-Check</ListItemText>
            </ListItemButton>
          </List>
        </Grid>

        <Grid item xs={9}>
          <Collapse in={currentView === SETTING_SITE.GLOBAL}>
            <NotReadyYet />
          </Collapse>

          <Collapse in={currentView === SETTING_SITE.GROUPS}>
            <UserGroupOverview />
          </Collapse>

          <Collapse in={currentView === SETTING_SITE.USER}>
            <UserOverview />
          </Collapse>

          <Collapse in={ofActive && currentView === SETTING_SITE.OF_DIALOGS}>
            <OpenFormulareDialogsView />
          </Collapse>

          <Collapse in={currentView === SETTING_SITE.LOCATIONS}>
            <LocationOverview />
          </Collapse>

          <Collapse in={currentView === SETTING_SITE.APPOINTMENTS}>
            <MeetingBookingSettings />
          </Collapse>

          <Collapse in={currentView === SETTING_SITE.FS_Directories}>
            <FSDirectoryOverview />
          </Collapse>

          <Collapse in={currentView === SETTING_SITE.COURTS}>
            {currentView === SETTING_SITE.COURTS && <CourtOverview />}
          </Collapse>
          <Collapse in={currentView === SETTING_SITE.LANDREGISTER}>
            <LandregisterSettingOverview />
          </Collapse>

          <Collapse in={currentView === SETTING_SITE.POSTCODES}>
            <PostcodeAdminOverview />
          </Collapse>

          <Collapse in={currentView === SETTING_SITE.LANGUAGE}>
            <LanguageSectionOverview />
          </Collapse>

          <Collapse in={currentView === SETTING_SITE.APPS}>
            <ExtensionsView />
          </Collapse>

          <Collapse
            in={
              tabletServiceActive &&
              currentView === SETTING_SITE.DEVICES_TABLETS
            }
          >
            <TabletsView />
          </Collapse>

          <Collapse in={currentView === SETTING_SITE.HEALTH_CHECK}>
            <HealthCheckView />
          </Collapse>
        </Grid>
      </Grid>

      <Drawer variant='permanent' open></Drawer>
    </>
  );
};
